<template>
  <div class="container bg-div">
    <h1 class="text-center h1">三大解决方案</h1>
    <p class="text-center text-p">我们仅针对制造行业，致力于提升工场现场管理信息化<br />融合精益生产的理念和工具，为工场提供实用的生产管理智能化解决方案。</p>
    <b-container>
      <b-row align-h="center">
        <b-col cols="3">
          <div
            :class="linkClass(0)"
            @mouseenter="didSelect(0)"
          >
            <img
              class="img-ico"
              v-if="show === 0"
              src="@/assets/images/solution-content-ico_1.png"
            >
            <img
              class="img-ico"
              v-else
              src="@/assets/images/solution-content-ico_4.png"
            >
            <p class="p-title text-center">云服务</p>
            <p class="p-info text-center">客户需要借助智能手机平台，下载注册即可使用玩转工场APP，无需其他硬件。功能如异常停线(andon)、故障报修、安全风险、维护保养、物料管理等免费使用，可以满足大部分工场生产管理的基本需求低成本、启动快</p>
            <b-button
              to="/solution"
              class="btn-did"
              variant="outline-primary"
            >点击查看</b-button>
          </div>
        </b-col>
        <b-col cols="3">
          <div
            :class="linkClass(1)"
            @mouseenter="didSelect(1)"
          >
            <img
              class="img-ico"
              v-if="show === 1"
              src="@/assets/images/solution-content-ico_2.png"
            >
            <img
              class="img-ico"
              v-else
              src="@/assets/images/solution-content-ico_5.png"
            >
            <p class="p-title text-center">本地化</p>
            <p class="p-info text-center">针对数据安全要求较高的客户，在内部服务器构建玩转工厂APP使用环境，运营数据保存在客户本地，满足客户对数据安全的最高要求。同时可以辅助终端硬件如PDA(andon)、故障报修、安全风险、维护保养、物料管理等免费使用，可以满足大部分工场生产管理的基本需求低成本、启动快</p>
            <b-button
              to="/solution"
              class="btn-did"
              variant="outline-primary"
            >点击查看</b-button>
          </div>
        </b-col>
        <b-col cols="3">
          <div
            :class="linkClass(2)"
            @mouseenter="didSelect(2)"
          >
            <img
              class="img-ico"
              v-if="show === 2"
              src="@/assets/images/solution-content-ico_3.png"
            >
            <img
              class="img-ico"
              v-else
              src="@/assets/images/solution-content-ico_6.png"
            >
            <p class="p-title text-center">定制化</p>
            <p class="p-info text-center">满足客户的个性化需求，深度定制。可基于客户已有的管理流程、软件系统、终端硬件，也可使用新的硬件，再结合玩转工厂APP的移动属性，开发出属于自己的更加智能和高效的管理系统(andon)、故障报修、安全风险、维护保养、物料管理等免费使用，可以满足大部分工场生产管理的基本需求低成本、启动快</p>
            <b-button
              to="/solution"
              class="btn-did"
              variant="outline-primary"
            >点击查看</b-button>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
export default {
  name: "HomeContentSolution",
  data() {
    return {
      show: 4,
    };
  },
  methods: {
    didSelect(ids) {
      this.show = ids;
    },
    linkClass(idx) {
      if (this.show === idx) {
        return ["div-bg-s"];
      } else {
        return ["div-bg"];
      }
    },
  },
};
</script>

<style lang="stylus" scoped>
.h1 {
  padding-top: 5rem;
  color: #333333;
  font-size: 1.9rem;
  line-height: 0.9rem;
  letter-spacing: 0rem;
}

.text-p {
  padding-top: 2rem;
  font-size: 0.9rem;
  line-height: 1.3rem;
  letter-spacing: 0rem;
  color: #666666;
}

.div-bg {
  width: 16.7rem;
  height: 28.1rem;
  margin-top: 3rem;
  margin-bottom: 5rem;
}

.div-bg-s {
  width: 16.7rem;
  height: 28.1rem;
  margin-top: 3rem;
  margin-bottom: 5rem;
  box-shadow: 0.2rem 0.5rem 1rem 0rem rgba(3, 0, 0, 0.23);
}

.img-ico {
  width: 5.6rem;
  height: 5.6rem;
  margin-top: 1rem;
  margin-left: 50%;
  transform: translateX(-50%);
}

.p-title {
  margin-top: 1rem;
  font-size: 0.9rem;
  line-height: 1.3rem;
}

.p-info {
  width: 12rem;
  height: 12.5rem;
  margin-left: 50%;
  transform: translateX(-50%);
  font-size: 0.8rem;
  line-height: 1.3rem;
}

.btn-did {
  margin-left: 50%;
  transform: translateX(-50%);
}
</style>



// WEBPACK FOOTER //
// src/pages/home/components/ContentSolution.vue